import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import styles from './Popup.module.css';

interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
}

const Popup: React.FC<PopupProps> = ({ isOpen, onClose, children, title }) => {
  // ESC tuşu ile kapatma özelliği
  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      document.body.style.overflow = 'unset';
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={styles.popupOverlay} onClick={onClose}>
      <div
        className={styles.popupContent}
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? 'popup-title' : undefined}
      >
        <div className={styles.popupHeader}>
          {title && (
            <h2 id="popup-title" className={styles.popupTitle}>
              {title}
            </h2>
          )}
          <button onClick={onClose} className={styles.closeButton} aria-label="Kapat">
            <X size={24} />
          </button>
        </div>
        <div className={styles.popupBody}>{children}</div>
      </div>
    </div>
  );
};

export default Popup;
